export const SHOW_NEW_TEMPLATE_MODAL = 'SHOW_NEW_TEMPLATE_MODAL';
export const SET_IS_MANAGE_TEMPLATE_CATEGORIES_MODAL_OPEN = 'SET_IS_MANAGE_TEMPLATE_CATEGORIES_MODAL_OPEN';
export const PREVIEW_TEMPLATE_ID_SET = 'PREVIEW_TEMPLATE_ID_SET';
export const DUPLICATE_TEMPLATE_ID_SET = 'DUPLICATE_TEMPLATE_ID_SET';
export const DELETE_TEMPLATE_ID_SET = 'DELETE_TEMPLATE_ID_SET';

export const TEMPLATE_CREATE_START = 'TEMPLATE_CREATE_START';
export const TEMPLATE_CREATE_API = 'TEMPLATE_CREATE_API';
export const TEMPLATE_CREATE_API_FULFILLED = 'TEMPLATE_CREATE_API_FULFILLED';
export const TEMPLATE_CREATE_API_REJECTED = 'TEMPLATE_CREATE_API_REJECTED';

export const TEMPLATE_UPDATE_START = 'TEMPLATE_UPDATE_START';
export const TEMPLATE_UPDATE_API = 'TEMPLATE_UPDATE_API';
export const TEMPLATE_UPDATE_API_FULFILLED = 'TEMPLATE_UPDATE_API_FULFILLED';
export const TEMPLATE_UPDATE_API_REJECTED = 'TEMPLATE_UPDATE_API_REJECTED';

export const TEMPLATE_DELETE_START = 'TEMPLATE_DELETE_START';
export const TEMPLATE_DELETE_API = 'TEMPLATE_DELETE_API';
export const TEMPLATE_DELETE_API_FULFILLED = 'TEMPLATE_DELETE_API_FULFILLED';
export const TEMPLATE_DELETE_API_REJECTED = 'TEMPLATE_DELETE_API_REJECTED';

export const TEMPLATE_INSTANCE_FETCH_START = 'TEMPLATE_INSTANCE_FETCH_START';
export const TEMPLATE_INSTANCE_FETCH_API = 'TEMPLATE_INSTANCE_FETCH_API';
export const TEMPLATE_INSTANCE_FETCH_API_FULFILLED = 'TEMPLATE_INSTANCE_FETCH_API_FULFILLED';
export const TEMPLATE_INSTANCE_FETCH_API_REJECTED = 'TEMPLATE_INSTANCE_FETCH_API_REJECTED';

export const TEMPLATES_FETCH_START = 'TEMPLATES_FETCH_START';
export const TEMPLATES_FETCH_API = 'TEMPLATES_FETCH_API';
export const TEMPLATES_FETCH_API_FULFILLED = 'TEMPLATES_FETCH_API_FULFILLED';
export const TEMPLATES_FETCH_API_REJECTED = 'TEMPLATES_FETCH_API_REJECTED';

export const TEMPLATES_FETCH_SEARCH_START = 'TEMPLATES_FETCH_SEARCH_START';
export const TEMPLATES_FETCH_SEARCH_API = 'TEMPLATES_FETCH_SEARCH_API';
export const TEMPLATES_FETCH_SEARCH_API_FULFILLED = 'TEMPLATES_FETCH_SEARCH_API_FULFILLED';
export const TEMPLATES_FETCH_SEARCH_API_REJECTED = 'TEMPLATES_FETCH_SEARCH_API_REJECTED';

export const TEMPLATES_CLEAR_SEARCH = 'TEMPLATES_CLEAR_SEARCH';

export const RESET_TEMPLATES_HIGHLIGHTING_ROWS = 'RESET_TEMPLATES_HIGHLIGHTING_ROWS';

export const TEMPLATE_CATEGORIES_FETCH_START = 'TEMPLATE_CATEGORIES_FETCH_START';
export const TEMPLATE_CATEGORIES_FETCH_API = 'TEMPLATE_CATEGORIES_FETCH_API';
export const TEMPLATE_CATEGORIES_FETCH_API_FULFILLED = 'TEMPLATE_CATEGORIES_FETCH_API_FULFILLED';
export const TEMPLATE_CATEGORIES_FETCH_API_REJECTED = 'TEMPLATE_CATEGORIES_FETCH_API_REJECTED';

export const TEMPLATE_CATEGORY_CREATE_START = 'TEMPLATE_CATEGORY_CREATE_START';
export const TEMPLATE_CATEGORY_CREATE_API = 'TEMPLATE_CATEGORY_CREATE_API';
export const TEMPLATE_CATEGORY_CREATE_API_FULFILLED = 'TEMPLATE_CATEGORY_CREATE_API_FULFILLED';
export const TEMPLATE_CATEGORY_CREATE_API_REJECTED = 'TEMPLATE_CATEGORY_CREATE_API_REJECTED';
export const TEMPLATE_CATEGORY_UPDATE_START = 'TEMPLATE_CATEGORY_UPDATE_START';
export const TEMPLATE_CATEGORY_UPDATE_API = 'TEMPLATE_CATEGORY_UPDATE_API';
export const TEMPLATE_CATEGORY_UPDATE_API_FULFILLED = 'TEMPLATE_CATEGORY_UPDATE_API_FULFILLED';
export const TEMPLATE_CATEGORY_UPDATE_API_REJECTED = 'TEMPLATE_CATEGORY_UPDATE_API_REJECTED';
export const TEMPLATE_CATEGORY_DELETE_START = 'TEMPLATE_CATEGORY_DELETE_START';
export const TEMPLATE_CATEGORY_DELETE_API = 'TEMPLATE_CATEGORY_DELETE_API';
export const TEMPLATE_CATEGORY_DELETE_API_FULFILLED = 'TEMPLATE_CATEGORY_DELETE_API_FULFILLED';
export const TEMPLATE_CATEGORY_DELETE_API_REJECTED = 'TEMPLATE_CATEGORY_DELETE_API_REJECTED';

export const TEMPLATE_ADD_TO_RECENTLY_USED = 'TEMPLATE_ADD_TO_RECENTLY_USED';
export const ACTIVE_TEMPLATES_FETCH_RECENTLY_USED = 'ACTIVE_TEMPLATES_FETCH_RECENTLY_USED';
export const ACTIVE_TEMPLATES_SET_RECENTLY_USED = 'ACTIVE_TEMPLATES_SET_RECENTLY_USED';

export const ACTIVE_TEMPLATES_FETCH_START = 'ACTIVE_TEMPLATES_FETCH_START';
export const ACTIVE_TEMPLATES_FETCH_API = 'ACTIVE_TEMPLATES_FETCH_API';
export const ACTIVE_TEMPLATES_FETCH_API_FULFILLED = 'ACTIVE_TEMPLATES_FETCH_API_FULFILLED';
export const ACTIVE_TEMPLATES_FETCH_API_REJECTED = 'ACTIVE_TEMPLATES_FETCH_API_REJECTED';

export const TEMPLATE_CATEGORY_FETCH_TEMPLATES_START = 'FETCH_CATEGORY_TEMPLATES_START';
export const TEMPLATE_CATEGORY_FETCH_TEMPLATES_API = 'TEMPLATE_CATEGORY_FETCH_TEMPLATES_API';
export const TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_FULFILLED = 'TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_FULFILLED';
export const TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_REJECTED = 'TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_REJECTED';

export const showNewTemplateModalAction = visible => ({
  type: SHOW_NEW_TEMPLATE_MODAL,
  payload: visible
});

export const setPreviewTemplateIdAction = templateId => ({
  type: PREVIEW_TEMPLATE_ID_SET,
  payload: templateId
});

export const setDuplicateTemplateIdAction = templateId => ({
  type: DUPLICATE_TEMPLATE_ID_SET,
  payload: templateId
});

export const setDeleteTemplateIdAction = templateId => ({
  type: DELETE_TEMPLATE_ID_SET,
  payload: templateId
});

export const createTemplateAction = (attributes, {onSuccess, onError}) => ({
  type: TEMPLATE_CREATE_START,
  meta: {onSuccess, onError},
  payload: attributes
});

export const updateTemplateAction = (id, attributes, {onSuccess, onError}) => ({
  type: TEMPLATE_UPDATE_START,
  meta: {onSuccess, onError},
  payload: {
    id,
    attributes
  }
});

export const deleteTemplateAction = (id, {onSuccess, onError}) => ({
  type: TEMPLATE_DELETE_START,
  meta: {onSuccess, onError},
  payload: id
});

export const fetchIssueTemplateInstanceAction = templateId => ({
  type: TEMPLATE_INSTANCE_FETCH_START,
  payload: templateId
});

export const fetchIssueTemplatesAction = queryParams => ({
  type: TEMPLATES_FETCH_START,
  payload: queryParams
});

export const getTemplatesSearchResultsAction = search => ({
  type: TEMPLATES_FETCH_SEARCH_START,
  payload: search
});

export const clearTemplatesSearchResultsAction = () => ({
  type: TEMPLATES_CLEAR_SEARCH
});

export const resetTemplatesHighlightingRowsAction = () => ({
  type: RESET_TEMPLATES_HIGHLIGHTING_ROWS
});

export const fetchIssueTemplateCategoriesAction = () => ({
  type: TEMPLATE_CATEGORIES_FETCH_START
});

export const createTemplateCategoryAction = (attributes, {onSuccess, onError}) => ({
  type: TEMPLATE_CATEGORY_CREATE_START,
  meta: {onSuccess, onError},
  payload: attributes
});

export const updateTemplateCategoryAction = (id, attributes, {onSuccess, onError} = {}) => ({
  type: TEMPLATE_CATEGORY_UPDATE_START,
  meta: {onSuccess, onError, id},
  payload: {id, attributes}
});

export const openManageTemplateCategoriesModal = () => ({
  type: SET_IS_MANAGE_TEMPLATE_CATEGORIES_MODAL_OPEN,
  payload: true
});

export const closeManageTemplateCategoriesModal = () => ({
  type: SET_IS_MANAGE_TEMPLATE_CATEGORIES_MODAL_OPEN,
  payload: false
});

export const deleteTemplateCategoryAction = (categoryId, {templatesTarget, onSuccess, onError} = {}) => ({
  type: TEMPLATE_CATEGORY_DELETE_START,
  payload: {
    id: categoryId,
    templatesTarget
  },
  meta: {onSuccess, onError, id: categoryId}
});

export const fetchActiveTemplatesAction = () => ({
  type: ACTIVE_TEMPLATES_FETCH_START
});

export const addTemplateToRecentlyUsedAction = templateId => ({
  type: TEMPLATE_ADD_TO_RECENTLY_USED,
  payload: templateId
});

export const fetchRecentlyUsedTemplatesAction = () => ({
  type: ACTIVE_TEMPLATES_FETCH_RECENTLY_USED
});

export const fetchCategoryTemplatesAction = (id, {onSuccess, onError}) => ({
  type: TEMPLATE_CATEGORY_FETCH_TEMPLATES_START,
  payload: id,
  meta: {
    id,
    onSuccess,
    onError
  }
});
